import axios from "axios";
import axiosInstance, { baseAxios } from "./config";

export const api = axiosInstance;
export const apiBase = axios.create(baseAxios);
